const handleRoundPrice = (price:string) => {
    return (parseFloat(price)).toFixed(2).toString()
}

export default handleRoundPrice
